import type {LucideIcon} from 'lucide-react'
import {cn} from '@/lib/utils'
import {Icon} from '@/components/shared/Icon'

interface IconCircleProps {
    icon: LucideIcon
    size?: 'sm' | 'md' | 'lg'
    variant?: 'primary' | 'destructive' | 'muted' | 'success'
    className?: string
}

/* eslint-disable i18next/no-literal-string -- CSS class constants */
const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12',
}
const iconSizes = {sm: 'md' as const, md: 'lg' as const, lg: 'xl' as const}
const variantClasses = {
    primary: 'bg-primary/10 text-primary',
    destructive: 'bg-destructive/10 text-destructive',
    muted: 'bg-muted text-muted-foreground',
    success: 'bg-status-success-subtle text-status-success',
}
/* eslint-enable i18next/no-literal-string */

export function IconCircle({icon, size = 'lg', variant = 'primary', className}: IconCircleProps) {
    return (
        <div className={cn('rounded-full flex items-center justify-center shrink-0', sizeClasses[size], variantClasses[variant], className)}>
            <Icon icon={icon} size={iconSizes[size]}/>
        </div>
    )
}
